import pointsCO from  '../assets/images/puntos30.png'

export const ENV = process.env.ENVIRONMENT ? process.env.ENVIRONMENT : 'DEV'
export const LOCALE = process.env.LOCALE ? process.env.LOCALE : 'es-CO'


export const concourseId = {
  DEV: 400,
  PDN: 400,
}[ENV]

export const gameId = {
  DEV: 125,
  PDN: 128,
}[ENV]

export const gameIdDiversion = {
  DEV: 126,
  PDN: 129,
}[ENV]

export const datesActivity = {
  dateStartGame: '11 de Mayo',
  dateEndGame: '11 de Junio',
  dateWinners: '15 y 22 de Junio',
}

export const numWinners = 10

export const costActivity = {
  'es-DO': 30,
}[LOCALE]

export const costActivityImage = {
  'es-DO': pointsCO,
}[LOCALE]
